import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { routes } from "../../Routes";

import { getBukUploadHistory } from "../../API  Functions/InventoryFunctions";
import BulkUploadHistoryTable from "../SessionHistory/BulkInventoryHistoryTable";

const BulkUploadHistory = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [bulkUploadReport, setBulkUploadReport] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    // if (user_id) {
    GetBulkUploadReport();
    // }
  }, [currentLimit, currentOffset]);

  const GetBulkUploadReport = async () => {
    const payload = {
      offset: currentOffset,
      limit: currentLimit,
      user_id: user_id,
    };
    try {
      setloading(true);
      const res1 = await getBukUploadHistory(payload);
      console.log("GetBulkUploadReport==", res1);

      if (res1?.result?.status_code == 200) {
        setBulkUploadReport(res1?.result?.response);
      } else {
        setBulkUploadReport([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="Bulk Import History" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {/* <div className="font-extrabold mb-3">
                <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    {
                      title: <Link to={routes.purchase}>{t("settings")}</Link>,
                      key: "purchase",
                    },
                    { title: t("Bulk Import History") },
                  ]}
                  className="relative mt-3 font-semibold"
                />
              </div> */}
          {/* {loading ? (
            <ShimmerLoader />
          ) : (
            <> */}
          <div className=" mt-6">
            <BulkUploadHistoryTable
              loading={loading}
              additionalData={bulkUploadReport}
              pagination={(values) => {
                setCurrentLimit(values.limit);
                setCurrentOffset(values.offset);
              }}
            />
          </div>
          {/* </>
          )} */}
        </div>
      </div>
    </>
  );
};

export default BulkUploadHistory;
